<template>
  <div class="flex-box pl5 pr5 mb10 al-c" :style="compWidth()">
    <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }" v-if="typeData.label != ''">{{ typeData.label }}：</div>
    <div class="flex-1">
      <el-autocomplete class="w100" v-model="value" value-key="label" :fetch-suggestions="querySearchAsync" :placeholder="typeData.placeholder ? typeData.placeholder : '请输入' + typeData.label" @keyup.enter.native="keyEnter"></el-autocomplete>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutocompleteComp",
  props: ["type-data", "width", "colspan"],
  components: {},
  data() {
    return {
      value: this.typeData.value ? this.typeData.value : "",
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    },
    keyEnter() {
      this.$emit("handle-search");
    },
    querySearchAsync(value, cb) {
      this.$http
        .post(
          this.typeData.url,
          this.$qs.stringify({
            [this.typeData.key]: value,
          })
        )
        .then(({ data }) => {
          console.log(data);
          if (data.resCode == 200) {
            cb(data.resData);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
